export interface AuthResponse {
    id: string;
    username: string;
    email: string;
    avatar:string;
    roles: string[];
    role:string;
    token: string;
    refreshToken: string;
  }
  
  export interface AuthRequest {
    email: string;
    password: string;
  }
  
  export interface AuthState {
    userData: AuthResponse | null; 
    loginState: boolean;
    logoutState: boolean;
    loginSso: boolean;
    loading: boolean;
    token: string;
  }
  
  export const authInitialState: AuthState = {
    userData: null,
    loginState: false,
    logoutState: false,
    loginSso: false,
    loading: false,
    token: ''
  };